import axios from "axios";
import {
  getLoggedInUserDataByKey,
  isUserAuthenticated,
  logout,
} from "helpers/authUtils";
import { LOGIN_TOKEN } from "helpers/constants";

const invokeApi = (method, url, data) => {
  const baseUrl = getBaseUrl();

  url = baseUrl + url;

  let headers = isUserAuthenticated()
    ? { Authorization: "Bearer " + getLoggedInUserDataByKey(LOGIN_TOKEN) }
    : {};
  return axios({
    method: method,
    url: url,
    headers: headers,
    data: data,
  })
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      return err.response.data;
    });
};

const invokeExternalApi = (method, url, data, args) => {
  const param = args ? args : {};
  return axios({
    method: method,
    url: url,
    data: data,
    ...param,
  })
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      return err.response.data;
    });
};

const getBaseUrl = () => {
  let baseUrl = window.location.hostname;
  if (baseUrl === "localhost") {
    //base url for local host
    baseUrl = "https://localhost:5001/api";
    //baseUrl = "http://192.168.0.109:5000/api";
  } else {
    //base url for other environments
    // baseUrl = window.location.origin + "/WebApi/api"
    baseUrl = "https://api.mangaldeepfamilyshop.in/api";
  }

  return baseUrl;
};

//Add a response interceptor
axios.interceptors.response.use(
  function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    return response;
  },
  function (error) {
    if (
      (error.response.status === 401 ||
        (error.response.status === 403 &&
          window.location.pathname !== "/slip")) &&
      window.location.pathname !== "/" &&
      window.location.pathname !== "/login"
    ) {
      logout();
    }

    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    return Promise.reject(error);
  }
);

export { invokeApi, invokeExternalApi };
